var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.56659 3.45833L1.66659 1.55833L2.72492 0.5L17.4999 15.275L16.4416 16.3333L13.9999 13.9L13.6499 13.55C12.5249 14 11.2916 14.25 9.99992 14.25C5.83325 14.25 2.27492 11.6583 0.833252 8C1.48325 6.35 2.56659 4.91667 3.94992 3.84167L3.56659 3.45833ZM14.1666 8C14.1666 5.7 12.2999 3.83333 9.99992 3.83333C9.45825 3.83333 8.94992 3.94167 8.47492 4.13333L6.67492 2.33333C7.70825 1.95833 8.82492 1.75 9.99158 1.75C14.1583 1.75 17.7166 4.34167 19.1583 8C18.5499 9.55 17.5583 10.9083 16.2999 11.9583L13.8666 9.525C14.0583 9.05 14.1666 8.54167 14.1666 8ZM6.27492 6.16667L7.56659 7.45833C7.52492 7.63333 7.49992 7.81667 7.49992 8C7.49992 9.38333 8.61659 10.5 9.99992 10.5C10.1833 10.5 10.3666 10.475 10.5416 10.4333L11.8333 11.725C11.2749 12 10.6583 12.1667 9.99992 12.1667C7.69992 12.1667 5.83325 10.3 5.83325 8C5.83325 7.34167 5.99992 6.725 6.27492 6.16667ZM12.4916 8.14167L9.86659 5.51667L10.0083 5.50833C11.3916 5.50833 12.5083 6.625 12.5083 8.00833L12.4916 8.14167Z",
    fill: "#BBBEC9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeClose);
export default __webpack_public_path__ + "static/media/eyeClose.0f529859b0b9ead8904109c5faa60da0.svg";
export { ForwardRef as ReactComponent };